<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
  &copy; {{ year }} Vaultwarden. <br />
  {{ "versionNumber" | i18n: version }}
  <br/>
  Mon Dec  5 02:42:16 UTC 2022
  <br/>
  1e517d1319ec5ec815c3c27be6f33b3ffb981fc5
</div>
